import { StyleSheet } from 'aphrodite';

import {
  backgroundGrey,
  blackberry,
  coolGrey,
  greyStroke,
  shadowLight,
  softPurpleLight,
  white,
} from 'lib/css/colors';

export const galleryStyles = StyleSheet.create({
  galleryWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 12,
    flexShrink: 0,
  },
  galleryImageRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 28,
    borderRadius: 12,
    backgroundColor: white,
  },
  galleryNav: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 38,
    height: 38,
    borderRadius: '50%',
    border: 'none',
    backgroundColor: white,
    color: blackberry,
    boxShadow: `0 1px 6px ${shadowLight}`,
    cursor: 'pointer',
    zIndex: 2,
  },
  galleryNavLeft: { left: 6 },
  galleryNavRight: { right: 6 },
  galleryCounter: {
    color: coolGrey,
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 0.3,
  },
  galleryPlaceholderText: {
    color: coolGrey,
    fontSize: 13,
    fontWeight: 500,
  },
  zoomImage: {
    width: 560,
    height: 560,
    maxWidth: '100%',
    objectFit: 'contain',
    borderRadius: 8,
    backgroundColor: white,
    flexShrink: 0,
  },
  zoomImagePlaceholder: {
    width: 560,
    height: 560,
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: softPurpleLight,
    flexShrink: 0,
  },
  // Relative wrappers that anchor the count badge to the LEFT of an image.
  candImageInner: { position: 'relative', display: 'flex' },
  productImageInner: { position: 'relative', width: '100%', height: '100%' },
  // Count badge: sits just to the LEFT of the image (never over it), vertically centred.
  imageCountBadge: {
    position: 'absolute',
    right: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    marginRight: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    backgroundColor: backgroundGrey,
    color: coolGrey,
    border: `1px solid ${greyStroke}`,
    fontSize: 12,
    fontWeight: 700,
    padding: '3px 8px',
    borderRadius: 9,
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 1,
  },
});
